import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BrandLogo } from "@/components/AppLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLoginPage() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin-login", form);
      login(data.token, data.user);
      toast.success("Acceso admin concedido");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6">
      <div className="w-full max-w-sm bg-white border border-border p-8">
        <div className="mb-6"><BrandLogo /></div>
        <div className="flex items-center gap-2 mb-1">
          <Lock size={16} className="brand-text" />
          <h1 className="font-head text-xl font-bold text-slate-900">Panel de administración</h1>
        </div>
        <p className="text-sm text-muted-foreground mb-6">Acceso restringido a administradores.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label className="label-tiny">Email</Label>
            <Input data-testid="admin-email" type="email" required value={form.email} className="mt-1.5 rounded-none"
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label className="label-tiny">Contraseña</Label>
            <Input data-testid="admin-password" type="password" required value={form.password} className="mt-1.5 rounded-none"
              onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-submit"
            className="w-full rounded-none brand-bg text-white hover:opacity-90 h-11">
            {loading ? "Ingresando…" : "Ingresar"}
          </Button>
        </form>
        <p className="text-xs text-center text-muted-foreground mt-5">
          <Link to="/" className="underline">Volver al inicio</Link>
        </p>
      </div>
    </div>
  );
}
